<template>
  <div class="mall_group">
    <HeaderView title="店铺管理列表" />
    <TopBar ref="topBar" @updataList="updataList" :loading="tableInfo.loading" />
    <MyTable :info="tableInfo" @ChangePage="ChangePage">
      <template #platform>
        <div style="display: flex; align-items: center; justify-content: center">
          <img
            src="https://img.alicdn.com/tfs/TB1qEwuzrj1gK0jSZFOXXc7GpXa-32-32.ico"
            width="25"
            height="25"
            style="margin-right: 5px"
          />
          支付宝
        </div>
      </template>
      <template #shopName="{ record }">
        <!-- <a-tag v-if="isCurrentMall" color="red" style="font-size: 14px">当前店铺</a-tag> -->
        <a-tag v-if="record.IsMain" color="blue" style="font-size: 14px">主店铺</a-tag>
        <span class="name" v-if="record.auth">{{ record.auth.ShopName }}</span>
      </template>
      <template #appName="{ record }">
        {{ record.AppKey == Service_AppKey ? "支付宝应用" : "未知" }}
      </template>
      <template #appExpiresIn="{ record }">
        <span v-if="record.auth">{{ record.auth.AppExpiresIn }}</span>
      </template>
      <template #canSearchOrder="{ record }">
        <a-switch
          checked-children="开"
          un-checked-children="关"
          v-model:checked="record.CanSearchOrder"
          @click="updataMallGroupConfig(record, 'CanSearchOrder')"
        />
      </template>
      <template #canInvite="{ record }">
        <a-switch
          checked-children="开"
          un-checked-children="关"
          v-model:checked="record.CanInvite"
          @click="updataMallGroupConfig(record, 'CanInvite')"
        />
      </template>
      <template #operate="{ record }">
        <ShowAppAuthBtn :record="record" />
      </template>
    </MyTable>
  </div>
</template>
<script>
import TopBar from "./components/top_bar";
import handler from "./handler";
import { columns } from "./tableInfo";
import MyTable from "@/views/base/components/table";
import HeaderView from "@/views/base/components/header_view";
import { GetItemType } from "@/utils/constant/item";
import { Service_AppKey, Service_GetZfbMemberInfo } from "@/service/platform_config";
import ShowAppAuthBtn from "./components/show_app_auth_btn";
import { Service_SetPddMoveInfo } from "@/service/auth_mall_service";
import aliUtil from "@/utils/check_ali_auth";
export default {
  data() {
    return {
      GroupId: 0,
      tableInfo: {
        page: 1,
        pageSize: 100,
        showTotal: (total) => `共 ${total} 个店铺`,
        pageSizeOptions: ["20", "50", "100"],
        list: [],
        total: 0,
        tableScroll: { x: "1300px", y: "calc(100vh - 285px)" },
        loading: true,
        columns,
        rowSelection: null,
        renderSlot: ["platform", "shopName", "appName", "appExpiresIn", "operate", "canInvite", "canSearchOrder"],
        rowKey: "ShopId",
      },
      Service_AppKey,
    };
  },
  components: {
    TopBar,
    MyTable,
    HeaderView,
    ShowAppAuthBtn,
  },
  methods: {
    // 说明是单店铺
    setSingleMallData() {
      this.tableInfo.list = aliUtil.GetFormatMallData();
      this.tableInfo.total = this.tableInfo.list.length;
      this.tableInfo.columns = columns.filter((item) => !item.isMustMultiMall);
      this.tableInfo.loading = false;
      this.setLocalCurrentMall(this.tableInfo.list[0]);
    },
    updataList(GroupId, isInit) {
      // 如果 GroupId 不存在说明 改用户是新用户, 还没有创建过, 获取是删除了最后一个
      if (!GroupId) return this.setSingleMallData();
      this.GroupId = GroupId;
      // 如果是切换了店群 需要重置页码:1。
      if (isInit) this.tableInfo.page = 1;
      this.fillData("create-mall-group");
    },
    // 获取店群内所有的店铺
    async fillData(type) {
      const { page, pageSize } = this.tableInfo;
      var { mallList, success, msg, total } = await handler.GetMallListByGroupId(page, pageSize, this.GroupId);
      this.tableInfo.list = mallList;
      this.tableInfo.total = total;
      if (!success) this.$message.warn(msg);
      this.tableInfo.loading = false;
      if (mallList?.length && type === "create-mall-group") this.setLocalCurrentMall(mallList[0]);
    },
    setLocalCurrentMall(mall) {
      Service_SetPddMoveInfo(mall);
    },
    ChangePage(page, size) {
      this.tableInfo.page = page;
      this.tableInfo.pageSize = size;
      this.fillData();
    },
    getPlatformImg(PlatformType) {
      var info = GetItemType(PlatformType);
      return info.img;
    },
    isCurrentMall(record) {
      return record.ShopId == Service_GetZfbMemberInfo().shop_id;
    },
    async updataMallGroupConfig(record, modifyType) {
      // 1. 判断当前登录的店铺是不是这个店群的主店铺
      // var info = this.$refs.topBar.CheckCurrentMemberIsMainInMallGroupList();
      // if (!info) {
      //   this.$message.warn(
      //     `当前店铺【${Service_GetZfbMemberInfo().shop_name}】,不是主店铺无法操作,请登录【主店铺】进行操作!`
      //   );
      //   // 将修改的值重置回去
      //   record[modifyType] = !record[modifyType];
      //   return;
      // }
      // // 2. 主店铺,不能修改自己的配置
      // if (record.IsMain) {
      //   // 将修改的值重置回去
      //   record[modifyType] = !record[modifyType];
      //   return this.$message.warn(
      //     `当前登录的店铺【${Service_GetZfbMemberInfo().shop_name}】为【主店铺】,无法修改自己的配置!`
      //   );
      // }
      var { msg, success } = await handler.UpdataMallGroupConfig(record, modifyType);
      if (!success) return this.$message.warn(msg);
      this.$message.success("修改成功!");
    },
  },
};
</script>
<style lang="less" scoped>
.mall_group {
  .icon {
    width: 24px;
    height: 24px;
  }
}
</style>
